<template>
    <div class="animated fadeIn">
        <b-row v-if="userUnitId">
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Thông tin xác nhận đối chiếu dữ liệu</strong>
                    </div>
                    <b-form>
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Đơn vị xác nhận:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ verifyData.unitCode }} - {{ verifyData.unitName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Ngày xác nhận:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ verifyData.verifyDate | formatTime }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Người xác nhận:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label">{{ verifyData.verifyUserName }}</label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="text-center">
                                <h4>Tệp báo cáo đính kèm</h4>
                                <label>(Đơn vị đính kèm tệp báo cáo bản pdf xuất ra từ 02 <b>phần mềm Quản lý tài sản công</b> và <b>Kho CSDLQGTSC</b> đến 31/12/2020)</label>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 1:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(1, 1)">{{ verifyData.qltscFileName01 }}</a></label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 2:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(1, 2)">{{ verifyData.qltscFileName02 }}</a></label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 3:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(1, 3)">{{ verifyData.qltscFileName03 }}</a></label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 4:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(1, 4)">{{ verifyData.qltscFileName04 }}</a></label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <hr />
                    <b-form>
                        <b-row>
                            <b-col class="text-center">
                                <h4>Tệp báo cáo đính kèm</h4>
                                <label>(Đơn vị đính kèm tệp báo cáo bản pdf xuất ra từ 02 <b>phần mềm Quản lý công trình nước sạch</b> và <b>Kho CSDLQGTSC</b> đến 31/12/2020)</label>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 1:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(2, 1)">{{ verifyData.ctnsFileName01 }}</a></label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 2:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(2, 2)">{{ verifyData.ctnsFileName02 }}</a></label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 3:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(2, 3)">{{ verifyData.ctnsFileName03 }}</a></label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 4:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(2, 4)">{{ verifyData.ctnsFileName04 }}</a></label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <hr />
                    <b-form>
                        <b-row>
                            <b-col class="text-center">
                                <h4>Tệp báo cáo đính kèm</h4>
                                <label>(Đơn vị đính kèm tệp báo cáo bản pdf xuất ra từ 02 <b>phần mềm Quản lý hạ tầng giao thông đường bộ</b> và <b>Kho CSDLQGTSC</b> đến 31/12/2020)</label>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 1:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(3, 1)">{{ verifyData.htgtdbFileName01 }}</a></label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 2:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(3, 2)">{{ verifyData.htgtdbFileName02 }}</a></label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 3:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(3, 3)">{{ verifyData.htgtdbFileName03 }}</a></label>
                                </b-form-group>
                            </b-col>
                            <b-col md="6" offset-md="3">
                                <b-form-group label="Tệp đính kèm 4:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <label class="col-form-label"><a href="javascript:void(0)" @click="downloadFile(3, 4)">{{ verifyData.htgtdbFileName04 }}</a></label>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <br />
                        <b-row>
                            <b-col md="6" offset-md="3">
                                <b-form-group label=""
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-button type="button" variant="secondary" :to="{ path: './list' }">Quay lại</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { validationMixin } from 'vuelidate'
    import { mixins } from '@/shared/mixins'
    import { required, sameAs, minLength, helpers, requiredIf } from 'vuelidate/lib/validators'

    export default {
        name: 'VerifyDataDetail',
        mixins: [validationMixin, mixins],
        data() {
            return {
                verifyData: {
                    id: null,
                }
            }
        },
        computed: {
            verifyDataId() {
                return this.$route.params.verifyDataId;
            },
        },
        created() {
            var vm = this;
            this.$services.get(`data/verify-data/${this.verifyDataId}`).done(response => {
                vm.verifyData = response;
            })
        },
        methods: {
            downloadFile(type, position) {
                this.$services.download(`data/verify-data/${this.verifyData.id}/${type}/${position}/download`);
            },
        }
    }
</script>
<style scoped>
</style>
